import { Component, EventEmitter, Output } from '@angular/core';
import { DropdownOption } from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { ClientService } from '../../../../services/client.service';
import { Client } from '@mira-avant/mtlibs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DropdownFieldComponent } from '../../../fields/standard/dropdown-field/dropdown-field.component';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { first, Subscription } from 'rxjs';

@Component({
	selector: 'app-admin-client-selector-form',
	standalone: true,
	imports: [AngularModule, DropdownFieldComponent, ZorroModule, ThirdPartyModule],
	templateUrl: './admin-client-selector-form.component.html',
	styleUrl: './admin-client-selector-form.component.scss',
})
export class AdminClientSelectorFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup = this.fb.group({
		clientUuid: ['', []],
	});

	public options: DropdownOption[] = [];
	private sub: Subscription | undefined;

	constructor(
		private fb: FormBuilder,
		public clientService: ClientService
	) {
		this.sub = this.clientService.clients$.subscribe((clients: Client[]) => {
			this.options = clients.map((client: Client) => {
				return {
					value: client.uuid,
					label: client.active_text?.name || 'Unknown',
				};
			});
		});

		this.sub.add(
			this.clientService.selectedClient$.subscribe((client: Client) => {
				if (client) {
					this.form.patchValue({
						clientUuid: client.uuid,
					});
				}
			})
		);
	}

	ngOnInit() {}

	public onChange(uuid: unknown): void {
		this.clientService.selectedClient$.pipe(first()).subscribe((client: Client) => {
			if (client.uuid === uuid) {
				return;
			}

			this.onSubmitEmitter.emit(uuid);
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
